import { Separator } from '@change/ds-core-ui';

import { AdvocacySupport } from './components/AdvocacySupport';
import { EndorsementQuotes } from './components/EndorsementQuotes';
import { EndorsementsOverview } from './components/EndorsementsOverview';
import { EndorsersList } from './components/EndorsersList';
import { useEndorsementsSection } from './hooks/useEndorsements';

export const EndorsementsSection: React.FC = () => {
	const {
		data: { showEndorsements },
	} = useEndorsementsSection();

	if (!showEndorsements) return null;

	return (
		<div data-testid="endorsements-section">
			<Separator orientation="horizontal" className="my-14" />
			<EndorsementsOverview />
			<AdvocacySupport />
			<EndorsementQuotes />
			<EndorsersList />
		</div>
	);
};
